import base from './base2.repository';

export default {
    ...base,
    loadStores(filters, page){
        const params = {...filters, page: page};
        return this.get(`stores`, params);
    },
    loadStoreCategories(){
        return this.get(`stores/categories`);
    },
    saveStore(store) {
        return this.post(`stores`, store);
    },
    updateStore(store, id) {
        return this.put('stores/' + id, store);
    },
    deleteStore(id){
        return this.delete('stores/'+ id);
    },
    uploadPhoto(payload){
        return this.post('stores/upload-photo', payload)
    },
    saveLocation(payload){
        return this.post('stores/save-location', payload)
    },
    saveStorePhone(phone) {
        return this.post(`stores/phones`, phone);
    },
    updateStorePhone(phone, id) {
        return this.put('stores/phones/' + id, phone);
    },
    deleteStorePhone(id){
        return this.delete('stores/phones/'+ id);
    },
    saveStoreCategory(category) {
        return this.post(`stores/categories`, category);
    },
    deleteStoreCategory(id){
        return this.delete('stores/categories/'+ id);
    },
    assignCategories(payload){
        return this.post(`stores/assign-categories`, payload);
    },
    unassignCategory(payload){
        return this.post(`stores/unassign-category`, payload);
    }
}